import React from "react"

export interface DrawerData {
  title: string
  url: string
  alertText: string
  source: string
  type: string
}

interface Context {
  setDrawerOpen: (_drawerData: DrawerData) => void
}

const DrawerContext = React.createContext<Context>({setDrawerOpen: (_drawerData: DrawerData) => {}})

export default DrawerContext
